// Cada proveedor de POS informa por qué un cobro no se hizo a su manera, en texto libre. Un clasificador por proveedor lo
// traduce a lo que el cajero necesita saber; sin clasificador (o si no lo reconoce) se muestra lo que respondió el proveedor.

// Getnet: "CANCELADA(OPERACION CANCELADA)", "CANCELADA(TRANSACCION NEGADA)", "EXPIRADA(POS NO BUSCO TRANSACCION)". Se distingue entre
// lo que decidió el cajero (cancelar), lo que decidió el banco (denegar) y un cobro que el POS nunca tomó, porque el cajero hace
// algo distinto en cada caso.
const GETNET_DENIED = /NEGAD|DENEGAD|RECHAZ|DECLINAD/;

const classifyGetnet = (message) => {
  const text = String(message || '').toUpperCase();
  if (text.startsWith('EXPIRADA')) {
    return { severity: 'warning', title: 'El POS no tomó el cobro', message: 'Tocá la pantalla del POS apenas se envíe el cobro e intentá nuevamente.' };
  }
  if (GETNET_DENIED.test(text)) {
    return {
      severity: 'error',
      title: 'Transacción denegada',
      message: 'El POS denegó la transacción: no se realizó ningún cobro. Probá con otra tarjeta u otro medio de pago.',
    };
  }
  if (text.startsWith('CANCELADA')) {
    return { severity: 'warning', title: 'Cobro cancelado', message: 'La operación se canceló en el POS. No se realizó ningún cobro.' };
  }
  return null;
};

// Mercado Pago: el backend informa el estado de la order como "RECHAZADA(<motivo>)", "CANCELADA(<motivo>)", "EXPIRADA(<motivo>)"
// o "REEMBOLSADA" (motivos como rejected_by_issuer, insufficient_amount, canceled_on_terminal).
const classifyMercadoPago = (message) => {
  const text = String(message || '');
  const upper = text.toUpperCase();
  if (upper.startsWith('EXPIRADA')) {
    return {
      severity: 'warning',
      title: 'El cobro venció',
      message: 'No se pagó a tiempo y no se realizó ningún cobro. Si la terminal no recibió el cobro, tocá Actualizar o el botón verde del equipo e intentá nuevamente.',
    };
  }
  if (upper.startsWith('CANCELADA')) {
    return { severity: 'warning', title: 'Cobro cancelado', message: 'La operación se canceló en el POS. No se realizó ningún cobro.' };
  }
  if (upper.startsWith('REEMBOLSADA')) {
    return { severity: 'warning', title: 'Cobro reembolsado', message: 'El cobro se devolvió al cliente: no se registra como pagado.' };
  }
  if (upper.startsWith('RECHAZADA')) {
    const reason = /insufficient_amount/i.test(text) ? 'La tarjeta no tiene saldo suficiente.'
      : /rejected_by_issuer|card_disabled|required_call_for_authorize|high_risk/i.test(text) ? 'El banco emisor rechazó la operación.'
        : 'El POS rechazó la operación.';
    return { severity: 'error', title: 'Transacción denegada', message: `${reason} No se realizó ningún cobro. Probá con otra tarjeta u otro medio de pago.` };
  }
  return null;
};

const CLASSIFIERS = { GETNET: classifyGetnet, MERCADO_PAGO: classifyMercadoPago };

/** [provider] es el descriptor que informa /payments/pos/availability. */
export const posFailure = (message, provider) => {
  const classified = CLASSIFIERS[provider?.code]?.(message);
  if (classified) return classified;
  const name = provider?.displayName || 'El POS';
  return {
    severity: 'error',
    title: 'Pago rechazado',
    message: message ? `${name} respondió: ${message}` : `${name} rechazó la operación.`,
  };
};
